import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContentTab } from '../../project-data';
import { PublicYouTubeVideo } from '../../project-data';

@Component({
  selector: 'app-content-page',
  templateUrl: './content-page.component.html',
})
export class ContentPageComponent {
  @Input({ required: true }) contentTab!: ContentTab;
  @Input({ required: true }) youtubeVideos: PublicYouTubeVideo[] = [];
  @Input({ required: true }) youtubeLoading = false;
  @Input({ required: true }) youtubeError = false;
  @Output() readonly contentTabSelected = new EventEmitter<ContentTab>();
  @Output() readonly inquiryRequested = new EventEmitter<void>();

  protected videoDateLabel(video: PublicYouTubeVideo): string {
    if (!video.published_at) {
      return 'YouTube';
    }

    return new Intl.DateTimeFormat('en', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(video.published_at));
  }
}
